import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useEkengSettingsFetch = () => {
  const response = useQuery({
    queryKey: ['ekengSettings'],
    queryFn: () => api.ekeng.fetchSettings(),
    enabled: false, // Запрос выполняется только по требованию
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить настройки Ekeng',
      type: 'error',
      duration: 9000,
      isClosable: true,
    })
  }

  return response
}
